import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
    selector: 'app-languages',
    template: require('./languages.component.html')
})
export class LanguagesComponent implements OnInit {
    constructor(private translate: TranslateService) {}

    public languages: string[];
    public currentLanguage: string;

    ngOnInit(): void {
        this.languages = this.translate.getLangs();
        this.currentLanguage = this.translate.currentLang;

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.currentLanguage = event.lang;
        });
    }

    changeLanguage(lang: string) {
        this.translate.use(lang);
    }
}
